namespace $ {

	export class $shm_hitalama_map_widget_entity_form extends $giper_baza_entity.with({

		Query: $giper_baza_atom_text,
		Excluded_words: $giper_baza_atom_text,
		Date_from: $giper_baza_atom_text,
		Date_to: $giper_baza_atom_text,
		Country: $giper_baza_atom_text,
		Language: $giper_baza_atom_text,

		File_social_media: $giper_baza_atom_link.to( ()=> $shm_hitalama_file ),
		File_mass_media: $giper_baza_atom_link.to( ()=> $shm_hitalama_file ),

		Type: $giper_baza_atom_text,
		Tags: $giper_baza_atom_text,
		Category: $giper_baza_atom_text,

	}){

		query( next?: string ) {
			return this.Query(next)?.val(next) ?? ''
		}

		excluded_words( next?: string ) {
			return this.Excluded_words(next)?.val(next) ?? ''
		}

		date_from( next?: string ) {
			return this.Date_from(next)?.val(next) ?? ''
		}

		date_to( next?: string ) {
			return this.Date_to(next)?.val(next) ?? ''
		}

		country( next?: string ) {
			return this.Country(next)?.val(next) ?? ''
		}

		language( next?: string ) {
			return this.Language(next)?.val(next) ?? ''
		}

		type( next?: string ) {
			return this.Type(next)?.val(next) ?? ''
		}

		tags( next?: string ) {
			return this.Tags(next)?.val(next) ?? ''
		}

		category( next?: string ) {
			return this.Category(next)?.val(next) ?? ''
		}

		/** @deprecated Use period */
		prediod() {
			const from = this.Date_from()?.val()
			const to = this.Date_to()?.val()
			return (from && to) ? from + ' – ' + to : ''
		}

		period() {
			const from = this.Date_from()?.val()
			const to = this.Date_to()?.val()
			return (from && to) ? from + ' – ' + to : ''
		}

		social_media_title() {
			return this.File_social_media()?.remote()?.title() || ''
		}

		mass_media_title() {
			return this.File_mass_media()?.remote()?.title() || ''
		}

		@ $mol_mem
		table_row() {
			return [
				this.query(),
				this.excluded_words(),
				this.period(),
				this.country(),
				this.language(),
				this.File_social_media()?.remote()?.link()?.toString(),
				this.File_mass_media()?.remote()?.link()?.toString(),
				this.type(),
				this.tags(),
				this.category(),
				null,
			]
		}

		@ $mol_mem
		statistic_table_rows() {
			const rows: any[] = []
			this.File_mass_media()?.remote()?.text()?.split('\n')?.forEach( line => {
				const [ date, count ] = line.split(';')
				if( isNaN( Number( count ) ) ) return
				rows.push( [ date, count, this.query(), this.excluded_words(), 'СМИ', this.country(), this.language() ] )
			} )
			
			this.File_social_media()?.remote()?.text()?.split('\n')?.forEach( line => {
				const [ date, count ] = line.split(';')
				if( isNaN( Number( count ) ) ) return
				rows.push( [ date, count, this.query(), this.excluded_words(), 'Соц.медиа', this.country(), this.language() ] )
			} )
			return rows
		}
		
		@ $mol_action
		serialize() {
			return {
				ref: this.link().toString(),

				query: this.Query()?.val(),
				excluded_words: this.Excluded_words()?.val(),
				date_from: this.Date_from()?.val(),
				date_to: this.Date_to()?.val(),
				country: this.Country()?.val(),
				language: this.Language()?.val(),
				type: this.Type()?.val(),
				tags: this.Tags()?.val(),
				category: this.Category()?.val(),

				file_social_media_link: this.File_social_media()?.remote()?.link().toString(),
				file_mass_media_link: this.File_mass_media()?.remote()?.link().toString(),
			}
		}

		@ $mol_action
		deserialize_data( dto: ReturnType< $shm_hitalama_map_widget_entity_form['serialize'] > ) {
			this.Query( dto.query )?.val( dto.query )
			this.Excluded_words( dto.excluded_words )?.val( dto.excluded_words )
			this.Date_from( dto.date_from )?.val( dto.date_from )
			this.Date_to( dto.date_to )?.val( dto.date_to )
			this.Country( dto.country )?.val( dto.country )
			this.Language( dto.language )?.val( dto.language )
			this.Type( dto.type )?.val( dto.type )
			this.Tags( dto.tags )?.val( dto.tags )
			this.Category( dto.category )?.val( dto.category )
		}

		@ $mol_action
		deserialize_links( dto: ReturnType< $shm_hitalama_map_widget_entity_form['serialize'] >, ref_remap: Map< string, string > ) {
			const dto_old = dto as typeof dto & {
				file_social_media_ref?: string
				file_mass_media_ref?: string
			}

			const file_mass_media_link = dto.file_mass_media_link ?? dto_old.file_mass_media_ref
			if( file_mass_media_link ) {
				const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap.get( file_mass_media_link )! ), $shm_hitalama_file )
				this.File_mass_media(null)?.remote( file )
			}
			const file_social_media_link = dto.file_social_media_link ?? dto_old.file_social_media_ref
			if( file_social_media_link ) {
				const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap.get( file_social_media_link )! ), $shm_hitalama_file )
				this.File_social_media(null)?.remote( file )
			}
		}
		
	}

}
